// extracted by mini-css-extract-plugin
module.exports = {"partnershipCheckInStatsContainer":"PartnershipCheckInStats_partnershipCheckInStatsContainer__2ak1Y","note":"PartnershipCheckInStats_note__3yQRY"};